import React from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultModal from '../defaultModal/DefaultModal';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import TicketPaymentStatus from '../../../pages/paymentStatus/components/TicketPaymentStatus';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import useTranslation from '../../../../hooks/translation/useTranslation';

function TicketPaymentStatusModal({ payment, handleDownload }) {
  const { currentLanguage } = useTranslation();
  const {
    showTicketPaymentStatus,
    setShowTicketPaymentStatus,
  } = useModal();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const handleSet = (value) => {
    if (!value) {
      navigate(`/${currentLanguage || 'ka'}`);
    }
    setShowTicketPaymentStatus(value);
  };

  return (
    <DefaultModal
      width="629px"
      show={showTicketPaymentStatus && payment?.status && width >= 1024}
      setShow={handleSet}
    >
      <TicketPaymentStatus payment={payment} handleDownload={handleDownload} />
    </DefaultModal>
  );
}

export default TicketPaymentStatusModal;
